/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : TraceTrackCardWithTitle.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { componentStyle } from "../../../config/appTheme";
import ViewUploadedFile from "../../../components/file-upload/ViewUploadedFile";

function TraceTrackCardWithTitle({ data = [], title = "" }) {
  const [openPreview, setOpenPreview] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState("");

  return (
    <Box sx={{ pt: 2, pb: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Typography
          sx={{ textAlign: "left", ...componentStyle.font.cardHeadder }}
        >
          {title}
        </Typography>
      </Box>

      {data.map((item, index) => {
        const isFile = item?.valueType?.toLowerCase() === "file";
        const fileValue = item?.value;

        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: item.displayInSingleLine ? "row" : "column",
              textAlign: "left",
              flexWrap: item.displayInSingleLine ? "nowrap" : "wrap",
              ...item.style,
              mb: 1,
            }}
            key={index}
          >
            <Typography
              sx={{
                ...componentStyle.font.text,
                ...item.keyStyle,
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              {`${item.key}: `}
            </Typography>
            {isFile ? (
              <Button
                size="small"
                variant="text"
                disabled={!fileValue}
                onClick={() => {
                  setSelectedFile(fileValue);
                  setSelectedFileName(
                    item?.key == null ? "" : String(item.key),
                  );
                  setOpenPreview(true);
                }}
                sx={{
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  alignSelf: "flex-start",
                  width: "fit-content",
                  justifyContent: "flex-start",
                }}
              >
                View
              </Button>
            ) : (
              <Typography sx={{ ...componentStyle.font.text }}>
                {item.value || "-"}
              </Typography>
            )}
          </Box>
        );
      })}

      <ViewUploadedFile
        open={openPreview}
        onClose={() => {
          setOpenPreview(false);
          setSelectedFile(null);
          setSelectedFileName("");
        }}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        downloadFile={true}
        fileName={selectedFileName}
      />
    </Box>
  );
}

export default TraceTrackCardWithTitle;
